// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from './store'

import moment from 'moment-timezone'

moment.tz.setDefault('UTC')
Vue.prototype.$moment = moment

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask);

import { VueMaskFilter } from 'v-mask'
Vue.filter('VMask', VueMaskFilter)

import axios from 'axios';

axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN"

// RTA
// const baseurl = window.location.href
const baseurl = window.location.hostname
const endpoint = baseurl.concat('/api')

axios.defaults.baseURL = 'https://'.concat(endpoint)
// axios.defaults.baseURL = 'http://pgsa2.herokuapp.com/api'

axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    config.withCredentials = true;
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);

import Snotify, { SnotifyPosition } from 'vue-snotify';

const options = {
  toast: {
    position: SnotifyPosition.rightTop
  }
}

Vue.use(Snotify, options);

// todo
// cssVars()

Vue.use(BootstrapVue)

import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Esse campo é obrigatório.'
});

extend('email', {
  ...email,
  message: 'E-mail inválido'
});

extend('positive', value => {
  if (value >= 0) {
    return true;
  }

  return 'Precisa ser um número positivo';
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

import "./filters"

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})